var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1389 1.01143C12.4746 0.627894 11.6252 0.855494 11.2417 1.5198L4.01946 14.0291C3.63592 14.6934 3.86352 15.5428 4.52783 15.9263C5.19214 16.3099 6.04155 16.0823 6.42509 15.4179L13.6473 2.90869C14.0308 2.24438 13.8032 1.39497 13.1389 1.01143Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5198 8.01121C0.855493 8.39475 0.627894 9.24417 1.01143 9.90847L4.23365 15.4895C4.61719 16.1538 5.4666 16.3814 6.13091 15.9979C6.79522 15.6144 7.02282 14.7649 6.63928 14.1006L3.41706 8.51958C3.03352 7.85528 2.18411 7.62768 1.5198 8.01121Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.9fb4dd09c5861e2932a15aa5b99d83a4.svg";
export { ForwardRef as ReactComponent };